<template>
  <div class="result-fail-wrapper" :style="{'padding-bottom': safePadding + 'px'}">
    <img v-if="timeout" src="../../assets/crf/downcount.png" />
    <img v-else src="../../assets/crf/inexist.png" />
    <div class="desc1">抱歉</div>
    <div class="desc2">{{ timeout ? '已过问卷截止时间' : (reason || '问卷不存在') }}</div>
    <div class="btn" @click="close">关闭</div>
  </div>
  
</template>

<script>

export default {
  name: 'ResultFail',
  props: {
    timeout: {
      type: Boolean,
      default: false
    },
    reason: {
      type: String,
      default: ''
    }
  },
  computed: {
    safePadding() {
      return 36 + (+(this.$route.query.safeBottom || 0))
    },
  },
  data() {
    return {
    };
  },
  methods: {
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
$safe-area-inset-bottom: constant(safe-area-inset-bottom);
$safe-area-inset-bottom: env(safe-area-inset-bottom);
.result-fail-wrapper {
  position: absolute;
  bottom: 0;
  width: 100%;
  text-align: center;
  font-size: 28px;
  color: #3A3B3C;
  background: #fff;
  padding-bottom: calc(1px + $safe-area-inset-bottom);
  border-radius: 24px 24px 0 0;
  img {
    width: 240px;
    height: 240px;
    margin-top: 64px;
  }
  .desc1 {
    color: #89898A;
    margin-top: 24px;
  }
  .desc2 {
    font-weight: 500;
    font-size: 32px;
    line-height: 44px;
    margin-top: 16px;
    font-family: PingFangSC, PingFang SC;
  }
  .desc3 {
    margin-top: 20px;
  }
  .btn {
    width: 326px;
    height: 88px;
    line-height: 88px;
    background: linear-gradient( 153deg, #FF7673 0%, #FF3D3D 100%);
    border-radius: 48px;
    font-weight: 500;
    color: #FFFFFF;
    margin: 80px auto 40px;
  }
}

</style>
